module.exports = __webpack_public_path__ + "static/img/logo.b8c9b3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.jpg
// module id = 4Uwr
// module chunks = 1